/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `employee` - Employee
 * * `customer` - Customer
 * @export
 */
export const OwnerEnum = {
    Employee: 'employee',
    Customer: 'customer'
} as const;
export type OwnerEnum = typeof OwnerEnum[keyof typeof OwnerEnum];


export function instanceOfOwnerEnum(value: any): boolean {
    for (const key in OwnerEnum) {
        if (Object.prototype.hasOwnProperty.call(OwnerEnum, key)) {
            if (OwnerEnum[key as keyof typeof OwnerEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OwnerEnumFromJSON(json: any): OwnerEnum {
    return OwnerEnumFromJSONTyped(json, false);
}

export function OwnerEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): OwnerEnum {
    return json as OwnerEnum;
}

export function OwnerEnumToJSON(value?: OwnerEnum | null): any {
    return value as any;
}

export function OwnerEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): OwnerEnum {
    return value as OwnerEnum;
}

